import apiCore from "services/apiCore";

const BASE_URI = "/voicemail/messages/";

const voicemailService = {
    getVoicemail: function (voicemailId) {
        return apiCore.v2.get(BASE_URI + voicemailId);
    },

    getVoicemailMedia: function (voicemailId, formatId) {
        const parameters = {};
        if (formatId) {
            parameters.formatId = formatId;
        }
        return apiCore.v2.get(BASE_URI + voicemailId + "/media", parameters);
    },

    deleteVoicemail: function (voicemailId) {
        return apiCore.v2.patch(BASE_URI + voicemailId, {
            deleted: true,
            deleteRetentionPolicy: {
                voicemailRetentionPolicyType: "IMMEDIATE_DELETE",
            },
        });
    },

    updateVoicemailRetention: function (voicemailId, deleteRetentionPolicy) {
        return apiCore.v2.patch(BASE_URI + voicemailId, {
            deleteRetentionPolicy: deleteRetentionPolicy,
        });
    },
};
export default voicemailService;
